import Button from '@components/Button'
import { CardSection } from '@components/CardSection'
import { withRouter } from '@i18n/utils'
import { addressToStringSelector } from 'basket/selectors'

const MonthlyAddressSection = ({ deliveryAddress, disabled }) => (
    <CardSection title={<T>booking.monthly.confirm-address</T>} className="select" disabled={disabled}>
        {deliveryAddress ? (
            <>
                <b>{deliveryAddress}</b>
                <Button btnStyle="link" size="small" iconLeft="edit" className="mt-3" href="/dashboard/account">
                    <T>booking.monthly.edit-address</T>
                </Button>
            </>
        ) : (
            <div className="row">
                <div className="col-sm-7">
                    <span className="text-red text-small">
                        <T>booking.monthly.missing-address-error</T>
                    </span>
                </div>
                <div className="col-sm-5 d-flex flex-column align-items-end mt-3 mt-sm-0">
                    <Button block={true} size="large" href="/dashboard/account">
                        <T>booking.monthly.add-address</T>
                    </Button>
                </div>
            </div>
        )}
    </CardSection>
)
export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            deliveryAddress: addressToStringSelector,
        })
    )
)(MonthlyAddressSection)
